import { X_URL, TELEGRAM_URL, GMGN_URL, DEXSCREENER_URL, SOLSCAN_TOKEN_URL, PUMPFUN_URL, PUMPFUN_CREATOR_URL, CHARITY_URL, CHARITY_NAME, CHARITY_PCT } from "../config";

const TRADE_LINKS = [
    { label: "GMGN", href: GMGN_URL },
    { label: "DEXSCREENER", href: DEXSCREENER_URL },
    { label: "SOLSCAN", href: SOLSCAN_TOKEN_URL },
    { label: "PUMPFUN", href: PUMPFUN_URL },
    { label: "DEV ON PUMP.FUN", href: PUMPFUN_CREATOR_URL },
];

export default function Footer() {
    return (
        <footer data-testid="footer" className="relative border-t border-cyan-400/10 bg-[#03040A]">
            <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-10">
                <div className="grid gap-12 md:grid-cols-3">
                    <div>
                        <div className="flex items-center gap-3">
                            <img
                                src="/images/brand/logo-64.png"
                                alt="BALD PIGEON logo"
                                className="h-12 w-12 rounded-full ring-2 ring-cyan-400/40"
                                loading="lazy"
                            />
                            <div>
                                <p className="font-display text-xl uppercase text-white">BALD PIGEON</p>
                                <p className="font-mono text-xs font-bold tracking-widest text-cyan-300">$BALD</p>
                            </div>
                        </div>
                        <p className="mt-4 font-mono text-xs uppercase tracking-widest text-slate-500">
                            JUST A BALD PIGEON ON SOLANA.
                        </p>
                    </div>

                    <div>
                        <p className="kicker">FOLLOW</p>
                        <a
                            href={X_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-x-link"
                            className="mt-4 block font-mono text-sm uppercase tracking-widest text-slate-300 hover:text-cyan-300"
                        >
                            X (TWITTER)
                        </a>
                        <a
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-telegram-link"
                            className="mt-3 block font-mono text-sm uppercase tracking-widest text-slate-300 hover:text-cyan-300"
                        >
                            TELEGRAM
                        </a>
                        <p className="kicker mt-8">GIVING BACK</p>
                        <a
                            href={CHARITY_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-charity-link"
                            className="mt-4 block font-mono text-sm uppercase tracking-widest text-slate-300 hover:text-cyan-300"
                        >
                            {CHARITY_NAME} — {CHARITY_PCT}% OF CREATOR REWARDS
                        </a>
                    </div>

                    <div>
                        <p className="kicker">TRADE</p>
                        <div className="mt-4 flex flex-col gap-3">
                            {TRADE_LINKS.map((l) => (
                                <a
                                    key={l.label}
                                    href={l.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`footer-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}-link`}
                                    className="font-mono text-sm uppercase tracking-widest text-slate-300 hover:text-cyan-300"
                                >
                                    {l.label}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="mt-14 border-t border-white/5 pt-8">
                    <p className="max-w-3xl text-xs leading-relaxed text-slate-500">
                        $BALD is a highly speculative cryptocurrency/memecoin. Nothing on this website constitutes
                        financial, investment or trading advice. Cryptocurrency markets are volatile and you can
                        lose some or all of your funds. Do your own research and never invest more than you can
                        afford to lose.
                    </p>
                    <div className="mt-6 flex flex-col justify-between gap-2 sm:flex-row">
                        <p className="font-mono text-xs text-slate-500">© 2026 BALD PIGEON</p>
                        <p className="font-mono text-xs uppercase tracking-widest text-slate-600">STAY BALD. 🕊️</p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
